const getQueryParameters = (
  search = window.location.search
): {
  [k: string]: string;
} => {
  const urlSearchParams: URLSearchParams = new URLSearchParams(search);

  return Object.fromEntries(urlSearchParams.entries());
};

export default getQueryParameters;
